import TimeUtil from '../../../backbone/utils/date/TimeUtil';
import NumberValidator from './NumberValidator';

export const validateInput = (value, config) => {
    let result;
    if (config.hourIncluded) {
        result = validateHoursMinutesAndSeconds(value, config);
    } else {
        result = validateMinutesAndSeconds(value, config);
    }
    return result;
};

const validateHoursMinutesAndSeconds = (value, config) => {
    if (!isValidTime(value, config.hourIncluded)) {
        return NumberValidator.Errors.InvalidNumber;
    }

    let totalSeconds = TimeUtil.hoursMinutesAndSecondsToSeconds(value);
    if (typeof config.minValue != 'undefined' && totalSeconds < config.minValue) {
        return NumberValidator.Errors.OutOfRange;
    }

    if (typeof config.maxValue != 'undefined' && totalSeconds > config.maxValue) {
        return NumberValidator.Errors.OutOfRange;
    }
};

const validateMinutesAndSeconds = (value, config) => {
    if (value.indexOf(':') === -1) {
        value += ':00';
    } else if (value.length > 1 && value.substring(0, 1) === ':') {
        value = '00' + value;
    }
    if (isValidTime(value, config.hourIncluded)) {
        let totalSeconds = 0;
        if (value.indexOf(':') > -1) {
            let temp = value.split(':');
            let minutes = parseInt(temp[0]);
            let seconds = parseInt(temp[1]);
            if (seconds >= 60) {
                minutes++;
                seconds -= 60;
            }
            if (minutes >= config.maxValue) {
                minutes += seconds;
            }
            totalSeconds = TimeUtil.hoursMinutesAndSecondsToSeconds(value);
            value = '' + minutes;
        }

        let numberValue = parseInt(value);

        if (typeof config.minValue != 'undefined' && numberValue < config.minValue && totalSeconds < config.minValue) {
            return NumberValidator.Errors.OutOfRange;
        }

        if (typeof config.maxValue != 'undefined' && numberValue > config.maxValue) {
            return NumberValidator.Errors.OutOfRange;
        }
    } else {
        return NumberValidator.Errors.InvalidNumber;
    }
};

const isValidTime = (time, hourIncluded) => {
    let regExp;
    if (hourIncluded) {
        // e.g., 00:10:15
        regExp = /^\d{1,2}:\d{1,2}:\d{1,2}$/;
    } else {
        // Must start with a number and have only one : and end in 2 numbers
        regExp = /^[0-9]+([:]{0,1})([0-9]{2})$/;
    }
    return regExp.test(time);
};

export default {
    validateInput
};
